/* eslint-disable */

'use strict';

// import Blockly from 'blockly';

export var profile;

export var img_path = 'img/';

export default function init(Blockly) {

    Blockly.Arduino = new Blockly.Generator('Arduino');

    /**
     * List of illegal variable names.
     * This is not intended to be a security feature.  Blockly is 100% client-side,
     * so bypassing this list is trivial.  This is intended to prevent users from
     * accidentally clobbering a built-in object or function.
     * @private
     */
    // http://arduino.cc/en/Reference/HomePage
    Blockly.Arduino.addReservedWords(
      "setup,loop,if,else,for,switch,case,while,do,break,continue,return,goto,define,include,HIGH,LOW,INPUT,OUTPUT,INPUT_PULLUP,true,false,integer, constants,floating,point,void,bookean,char,unsigned,byte,int,word,long,float,double,string,String,array,static, volatile,const,sizeof,pinMode,digitalWrite,digitalRead,analogReference,analogRead,analogWrite,tone,noTone,shiftOut,shitIn,pulseIn,millis,micros,delay,delayMicroseconds,min,max,abs,constrain,map,pow,sqrt,sin,cos,tan,randomSeed,random,lowByte,highByte,bitRead,bitWrite,bitSet,bitClear,bit,attachInterrupt,detachInterrupt,interrupts,noInterrupts,Servo,servo,keypad,Keypad,serial,Serial,Serial1, Serial2, Serial3,HardwareSerial,irremote,lcd,Lcd,stepper,Stepper,SoftwareSerial,bt_serial,fnc_bt_serial_namepin,LiquidCrystal_I2C,encoder,rtc,bt_serial,gps,gps_serial,fnc_gps_update,gps_lat,gps_lon,gps_speed_kmph,gps_speed_mph,gps_altitude,gps_course,gps_fixed,gps_day,gps_month,gps_year,gps_hour,gps_min,gps_sec,gps_hund,sd_file,fnc_sd_print,fnc_sd_filesize,fnc_sd_readbyte,fnc_sd_writebyte,fnc_EEPROM_readDouble,fnc_EEPROM_writeDouble,keypad_3x4_keys,keypad_3x4_rp,keypad_3x4_cp,keypad_3x4,fnc_adxl335,mqtt_mac,mqtt_broker,mqtt_port,mqtt_clientid,mqtt_user,mqtt_pass,mqtt_state,mqtt_payload,mqtt_ipclient,mqtt_client,mqtt_payload2double,mqtt_loop,mqtt_callback,mqtt_subscribe,mqtt_publish,mqtt_payload2string,pi,PI,Pi,pI,neo_pixel,lcd_customchar_,mfrc522,fnc_rfid_readID,l298n,l298n_,l298n_in1,l298_in2,l298n_in3,l298n_in4,l298n_ena,l298n_enb,button_debounced,button,Button,ir_rx,ir_tx,otto,robot_otto,Otto,AFMotor,AF_Stepper,AF_DCMotor,motorshield,fnc_dynamic_analogWrite,fnc_dynamic_analogRead,fnc_dynamic_digitalRead,fnc_dynamic_digitalWrite,_3dbot,fnc_3dbot_move,fnc_3dbot_motor,_3dbot_encoder,fnc_3dbot_distance,fnc_3dbot_ntc,nunchuk,ledmatrix,adxl345,fnc_adxl345,l298p,l298p_en1,l298p_en2,l298p_m1,l298p_m2,fnc_pm25,fnc_tcs34725_capturecolor,fnc_tcs34725_iscolor,tcs34725,Adafruit_TCS34725,tcs34725_r,tcs34725_g,tcs34725_b,tcs34725_clear,tcs34725_h,tcs34725_s,tcs34725_v,time_timer,fnc_interruptHandler,attachInterrupt,digitalPinToInterrupt,oscillator,pzem,pcf8574,bmp180,ds18b20,ina219,a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15,d0,d1,d2,d3,d4,d5,d6,d7,d8,d9,d10,d11,d12,d13,d14,d15,d16,time_snooze_sleeping,fnc_snooze,fnc_snooze_wakeup,fnc_snooze_sleep,rtc_time_text,rtc_date_text,rtcbuffer,mp3_player,paj7620,ccs811,param,request,vpin,blynk,mlx90614,sensor_ccs811,sensor_ccs811_lastread,sensor_ccs811_co2_ppm,sensor_ccs811_co2_ugm3,sensor_ccs811_co2_tvoc_ppb,vl53l0x,vl53l0x_measure,Adafruit_VL53L0X,touchRead,F,PROGMEM"
    );

    /**
     * Order of operation ENUMs.
     *
     */
    Blockly.Arduino.ORDER_ATOMIC = 0; // 0 "" ...
    Blockly.Arduino.ORDER_UNARY_POSTFIX = 1; // expr++ expr-- () [] .
    Blockly.Arduino.ORDER_UNARY_PREFIX = 2; // -expr !expr ~expr ++expr --expr
    Blockly.Arduino.ORDER_MULTIPLICATIVE = 3; // * / % ~/
    Blockly.Arduino.ORDER_ADDITIVE = 4; // + -
    Blockly.Arduino.ORDER_SHIFT = 5; // << >>
    Blockly.Arduino.ORDER_RELATIONAL = 6; // is is! >= > <= <
    Blockly.Arduino.ORDER_EQUALITY = 7; // == != === !==
    Blockly.Arduino.ORDER_BITWISE_AND = 8; // &
    Blockly.Arduino.ORDER_BITWISE_XOR = 9; // ^
    Blockly.Arduino.ORDER_BITWISE_OR = 10; // |
    Blockly.Arduino.ORDER_LOGICAL_AND = 11; // &&
    Blockly.Arduino.ORDER_LOGICAL_OR = 12; // ||
    Blockly.Arduino.ORDER_CONDITIONAL = 13; // expr ? expr : expr
    Blockly.Arduino.ORDER_ASSIGNMENT = 14; // = *= /= ~/= %= += -= <<= >>= &= ^= |=
    Blockly.Arduino.ORDER_COMMA = 15; // ,
    Blockly.Arduino.ORDER_UNARY_NEGATION = 16;
    Blockly.Arduino.ORDER_MEMBER = 17;
    Blockly.Arduino.ORDER_NONE = 99; // (...)

    var profile = {
      arduino_promicro: {
        description: "Arduino Pro Micro",
        micro: "atmelavr",
        digital: [
          ["0-RX", "0"],
          ["1-TX", "1"],
          ["2", "2"],
          ["3", "3"],
          ["4", "4"],
          ["5", "5"],
          ["6", "6"],
          ["7", "7"],
          ["8", "8"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"],
          ["12", "12"],
          ["13", "13"],
          ["A0", "A0"],
          ["A1", "A1"],
          ["A2", "A2"],
          ["A3", "A3"],
          ["A4", "A4"],
          ["A5", "A5"],
          ["A6", "A6"],
          ["A7", "A7"]
        ],
        rxtx: [
          ["0-RX", "0"],
          ["1-TX", "1"],
          ["8", "8"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"]
        ],
        PWM: [
          ["3", "3"],
          ["5", "5"],
          ["6", "6"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"]
        ],
        analog: [
          ["A0", "A0"],
          ["A1", "A1"],
          ["A2", "A2"],
          ["A3", "A3"],
          ["A4", "A4"],
          ["A5", "A5"],
          ["A6", "A6"],
          ["A7", "A7"]
        ],
        ir_rx: [
          ["0-RX", "0"],
          ["1-TX", "1"],
          ["2", "2"],
          ["3", "3"],
          ["4", "4"],
          ["5", "5"],
          ["6", "6"],
          ["7", "7"],
          ["8", "8"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"],
          ["12", "12"],
          ["13", "13"],
          ["A0", "A0"],
          ["A1", "A1"],
          ["A2", "A2"],
          ["A3", "A3"],
          ["A4", "A4"],
          ["A5", "A5"],
          ["A6", "A6"],
          ["A7", "A7"]
        ],
        ir_tx: [["3", "3"]],
        encoder_clk: [["2", "2"]],
        encoder_dt: [["3", "3"]],
        spi_mosi: [["11", "11"]],
        spi_miso: [["12", "12"]],
        spi_clk: [["13", "13"]],
        sd_cs: [["10", "10"]],
        picture: "media/Arduino-Nano-Pinout.jpg",
        miniPicture: "media/Arduino-Nano-Pinout-mini.jpg",
        serial: 9600,
        logic_levels: [
          ["%{BKY_BOOLEAN_ON}", "HIGH"],
          ["%{BKY_BOOLEAN_OFF}", "LOW"]
        ],
        ids: [
          ["1", "1"],
          ["2", "2"],
          ["3", "3"],
          ["4", "4"]
        ],
        sensor_range: [
          ["%", "PERCENT"],
          ["0..1023", "RAW"]
        ],
        intPins: [
          ["2", "2"],
          ["3", "3"]
        ],
        setupCode: [""],
        loopCode: [""],
        serialInt: [["Serial", ""]]
      },
      arduino_leonardo: {
        description: "Arduino Leonardo",
        micro: "atmelavr",
        digital: [
          ["0-RX", "0"],
          ["1-TX", "1"],
          ["2", "2"],
          ["3", "3"],
          ["4", "4"],
          ["5", "5"],
          ["6", "6"],
          ["7", "7"],
          ["8", "8"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"],
          ["12", "12"],
          ["13", "13"],
          ["A0", "A0"],
          ["A1", "A1"],
          ["A2", "A2"],
          ["A3", "A3"],
          ["A4", "A4"],
          ["A5", "A5"]
        ],
        rxtx: [
          ["0-RX", "0"],
          ["1-TX", "1"],
          ["8", "8"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"]
        ],
        PWM: [
          ["3", "3"],
          ["5", "5"],
          ["6", "6"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"]
        ],
        analog: [
          ["A0", "A0"],
          ["A1", "A1"],
          ["A2", "A2"],
          ["A3", "A3"],
          ["A4", "A4"],
          ["A5", "A5"]
        ],
        ir_rx: [
          ["0-RX", "0"],
          ["1-TX", "1"],
          ["2", "2"],
          ["3", "3"],
          ["4", "4"],
          ["5", "5"],
          ["6", "6"],
          ["7", "7"],
          ["8", "8"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"],
          ["12", "12"],
          ["13", "13"],
          ["A0", "A0"],
          ["A1", "A1"],
          ["A2", "A2"],
          ["A3", "A3"],
          ["A4", "A4"],
          ["A5", "A5"]
        ],
        ir_tx: [["3", "3"]],
        encoder_clk: [["2", "2"]],
        encoder_dt: [["3", "3"]],
        spi_mosi: [["11", "11"]],
        spi_miso: [["12", "12"]],
        spi_clk: [["13", "13"]],
        sd_cs: [["4", "4"]],
        picture: "media/Arduino-Uno-Pinout.jpg",
        miniPicture: "media/Arduino-Uno-Pinout-mini.jpg",
        serial: 9600,
        logic_levels: [
          ["%{BKY_BOOLEAN_ON}", "HIGH"],
          ["%{BKY_BOOLEAN_OFF}", "LOW"]
        ],
        ids: [
          ["1", "1"],
          ["2", "2"],
          ["3", "3"],
          ["4", "4"]
        ],
        sensor_range: [
          ["%", "PERCENT"],
          ["0..1023", "RAW"]
        ],
        intPins: [
          ["2", "2"],
          ["3", "3"]
        ],
        setupCode: [""],
        loopCode: [""],
        serialInt: [["Serial", ""]]
      },
      arduino_uno: {
        description: "Arduino Uno",
        micro: "atmelavr",
        digital: [
          ["0-RX", "0"],
          ["1-TX", "1"],
          ["2", "2"],
          ["3", "3"],
          ["4", "4"],
          ["5", "5"],
          ["6", "6"],
          ["7", "7"],
          ["8", "8"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"],
          ["12", "12"],
          ["13", "13"],
          ["A0", "A0"],
          ["A1", "A1"],
          ["A2", "A2"],
          ["A3", "A3"],
          ["A4", "A4"],
          ["A5", "A5"]
        ],
        rxtx: [
          ["0-RX", "0"],
          ["1-TX", "1"],
          ["2", "2"],
          ["3", "3"],
          ["4", "4"],
          ["5", "5"],
          ["6", "6"],
          ["7", "7"],
          ["8", "8"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"],
          ["12", "12"],
          ["A0", "A0"],
          ["A1", "A1"],
          ["A2", "A2"],
          ["A3", "A3"],
          ["A4", "A4"],
          ["A5", "A5"]
        ],
        PWM: [
          ["3", "3"],
          ["5", "5"],
          ["6", "6"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"]
        ],
        analog: [
          ["A0", "A0"],
          ["A1", "A1"],
          ["A2", "A2"],
          ["A3", "A3"],
          ["A4", "A4"],
          ["A5", "A5"],
          ["A6", "A6"],
          ["A7", "A7"]
        ],
        ir_rx: [
          ["0-RX", "0"],
          ["1-TX", "1"],
          ["2", "2"],
          ["3", "3"],
          ["4", "4"],
          ["5", "5"],
          ["6", "6"],
          ["7", "7"],
          ["8", "8"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"],
          ["12", "12"],
          ["13", "13"],
          ["A0", "A0"],
          ["A1", "A1"],
          ["A2", "A2"],
          ["A3", "A3"],
          ["A4", "A4"],
          ["A5", "A5"]
        ],
        ir_tx: [["3", "3"]],
        encoder_clk: [["2", "2"]],
        encoder_dt: [["3", "3"]],
        spi_mosi: [["11", "11"]],
        spi_miso: [["12", "12"]],
        spi_clk: [["13", "13"]],
        sd_cs: [["4", "4"]],
        picture: "media/Arduino-Uno-Pinout.jpg",
        miniPicture: "media/Arduino-Uno-Pinout-mini.jpg",
        serial: 9600,
        logic_levels: [
          ["%{BKY_BOOLEAN_ON}", "HIGH"],
          ["%{BKY_BOOLEAN_OFF}", "LOW"]
        ],
        ids: [
          ["1", "1"],
          ["2", "2"],
          ["3", "3"],
          ["4", "4"]
        ],
        sensor_range: [
          ["%", "PERCENT"],
          ["0..1023", "RAW"]
        ],
        intPins: [
          ["2", "2"],
          ["3", "3"]
        ],
        setupCode: [""],
        loopCode: [""],
        serialInt: [["Serial", ""]]
      },
      arduino_uno_lite: {
        actuator_led: [
          ["7", "7"],
          ["8", "8"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"],
          ["13", "13"],
          ["A0", "A0"],
          ["A1", "A1"]
        ],
        PWM: [
          ["9", "9"],
          ["10", "10"],
          ["11", "11"],
        ],
        digital: [
          ["7", "7"],
          ["8", "8"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"],
          ["A0", "A0"],
          ["A1", "A1"]
        ],
        potentiometer: [
          ["A0", "A0"],
          ["A1", "A1"]
        ],
        motor: [
          ["D2", "2"]
        ]
      },
      arduino_nano: {
        description: "Arduino Nano",
        micro: "atmelavr",
        digital: [
          ["0-RX", "0"],
          ["1-TX", "1"],
          ["2", "2"],
          ["3", "3"],
          ["4", "4"],
          ["5", "5"],
          ["6", "6"],
          ["7", "7"],
          ["8", "8"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"],
          ["12", "12"],
          ["13", "13"],
          ["A0", "A0"],
          ["A1", "A1"],
          ["A2", "A2"],
          ["A3", "A3"],
          ["A4", "A4"],
          ["A5", "A5"],
          ["A6", "A6"],
          ["A7", "A7"]
        ],
        rxtx: [
          ["0-RX", "0"],
          ["1-TX", "1"],
          ["2", "2"],
          ["3", "3"],
          ["4", "4"],
          ["5", "5"],
          ["6", "6"],
          ["7", "7"],
          ["8", "8"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"],
          ["12", "12"]
        ],
        PWM: [
          ["3", "3"],
          ["5", "5"],
          ["6", "6"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"]
        ],
        analog: [
          ["A0", "A0"],
          ["A1", "A1"],
          ["A2", "A2"],
          ["A3", "A3"],
          ["A4", "A4"],
          ["A5", "A5"],
          ["A6", "A6"],
          ["A7", "A7"]
        ],
        ir_rx: [
          ["0-RX", "0"],
          ["1-TX", "1"],
          ["2", "2"],
          ["3", "3"],
          ["4", "4"],
          ["5", "5"],
          ["6", "6"],
          ["7", "7"],
          ["8", "8"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"],
          ["12", "12"],
          ["13", "13"],
          ["A0", "A0"],
          ["A1", "A1"],
          ["A2", "A2"],
          ["A3", "A3"],
          ["A4", "A4"],
          ["A5", "A5"],
          ["A6", "A6"],
          ["A7", "A7"]
        ],
        ir_tx: [["3", "3"]],
        encoder_clk: [["2", "2"]],
        encoder_dt: [["3", "3"]],
        spi_mosi: [["11", "11"]],
        spi_miso: [["12", "12"]],
        spi_clk: [["13", "13"]],
        sd_cs: [["10", "10"]],
        picture: "media/Arduino-Nano-Pinout.jpg",
        miniPicture: "media/Arduino-Nano-Pinout-mini.jpg",
        serial: 9600,
        logic_levels: [
          ["%{BKY_BOOLEAN_ON}", "HIGH"],
          ["%{BKY_BOOLEAN_OFF}", "LOW"]
        ],
        ids: [
          ["1", "1"],
          ["2", "2"],
          ["3", "3"],
          ["4", "4"]
        ],
        sensor_range: [
          ["%", "PERCENT"],
          ["0..1023", "RAW"]
        ],
        intPins: [
          ["2", "2"],
          ["3", "3"]
        ],
        setupCode: [""],
        loopCode: [""],
        serialInt: [["Serial", ""]]
      },
      arduino_mega: {
        description: "Arduino Mega",
        micro: "atmelavr",
        digital: [
          ["0-RX", "0"],
          ["1-TX", "1"],
          ["2", "2"],
          ["3", "3"],
          ["4", "4"],
          ["5", "5"],
          ["6", "6"],
          ["7", "7"],
          ["8", "8"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"],
          ["12", "12"],
          ["13", "13"],
          ["14-TX(3)", "14"],
          ["15-RX(3)", "15"],
          ["16-TX(2)", "16"],
          ["17-RX(2)", "17"],
          ["18-TX(1)", "18"],
          ["19-RX(1)", "19"],
          ["20", "20"],
          ["21", "21"],
          ["22", "22"],
          ["23", "23"],
          ["24", "24"],
          ["25", "25"],
          ["26", "26"],
          ["27", "27"],
          ["28", "28"],
          ["29", "29"],
          ["30", "30"],
          ["31", "31"],
          ["32", "32"],
          ["33", "33"],
          ["34", "34"],
          ["35", "35"],
          ["36", "36"],
          ["37", "37"],
          ["38", "38"],
          ["39", "39"],
          ["40", "40"],
          ["41", "41"],
          ["42", "42"],
          ["43", "43"],
          ["44", "44"],
          ["45", "45"],
          ["46", "46"],
          ["47", "47"],
          ["48", "48"],
          ["49", "49"],
          ["50", "50"],
          ["51", "51"],
          ["52", "52"],
          ["A0", "A0"],
          ["A1", "A1"],
          ["A2", "A2"],
          ["A3", "A3"],
          ["A4", "A4"],
          ["A5", "A5"],
          ["A6", "A6"],
          ["A7", "A7"],
          ["A8", "A8"],
          ["A9", "A9"],
          ["A10", "A10"],
          ["A11", "A11"],
          ["A12", "A12"],
          ["A13", "A13"],
          ["A14", "A14"],
          ["A15", "A15"]
        ],
        rxtx: [
          ["0-RX", "0"],
          ["1-TX", "1"],
          ["10", "10"],
          ["11", "11"],
          ["12", "12"],
          ["13", "13"],
          ["14-TX(3)", "14"],
          ["15-RX(3)", "15"],
          ["16-TX(2)", "16"],
          ["17-RX(2)", "17"],
          ["18-TX(1)", "18"],
          ["19-RX(1)", "19"],
          ["50", "50"],
          ["51", "51"],
          ["52", "52"]
        ],
        PWM: [
          ["2", "2"],
          ["3", "3"],
          ["4", "4"],
          ["5", "5"],
          ["6", "6"],
          ["7", "7"],
          ["8", "8"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"],
          ["12", "12"],
          ["13", "13"],
          ["44", "44"],
          ["45", "45"],
          ["46", "46"]
        ],
        analog: [
          ["A0", "A0"],
          ["A1", "A1"],
          ["A2", "A2"],
          ["A3", "A3"],
          ["A4", "A4"],
          ["A5", "A5"],
          ["A6", "A6"],
          ["A7", "A7"],
          ["A8", "A8"],
          ["A9", "A9"],
          ["A10", "A10"],
          ["A11", "A11"],
          ["A12", "A12"],
          ["A13", "A13"],
          ["A14", "A14"],
          ["A15", "A15"]
        ],
        ir_rx: [
          ["0-RX", "0"],
          ["1-TX", "1"],
          ["2", "2"],
          ["3", "3"],
          ["4", "4"],
          ["5", "5"],
          ["6", "6"],
          ["7", "7"],
          ["8", "8"],
          ["9", "9"],
          ["10", "10"],
          ["11", "11"],
          ["12", "12"],
          ["13", "13"],
          ["14-TX(3)", "14"],
          ["15-RX(3)", "15"],
          ["16-TX(2)", "16"],
          ["17-RX(2)", "17"],
          ["18-TX(1)", "18"],
          ["19-RX(1)", "19"],
          ["20", "20"],
          ["21", "21"],
          ["22", "22"],
          ["23", "23"],
          ["24", "24"],
          ["25", "25"],
          ["26", "26"],
          ["27", "27"],
          ["28", "28"],
          ["29", "29"],
          ["30", "30"],
          ["31", "31"],
          ["32", "32"],
          ["33", "33"],
          ["34", "34"],
          ["35", "35"],
          ["36", "36"],
          ["37", "37"],
          ["38", "38"],
          ["39", "39"],
          ["40", "40"],
          ["41", "41"],
          ["42", "42"],
          ["43", "43"],
          ["44", "44"],
          ["45", "45"],
          ["46", "46"],
          ["47", "47"],
          ["48", "48"],
          ["49", "49"],
          ["50", "50"],
          ["51", "51"],
          ["52", "52"],
          ["A0", "A0"],
          ["A1", "A1"],
          ["A2", "A2"],
          ["A3", "A3"],
          ["A4", "A4"],
          ["A5", "A5"],
          ["A6", "A6"],
          ["A7", "A7"],
          ["A8", "A8"],
          ["A9", "A9"],
          ["A10", "A10"],
          ["A11", "A11"],
          ["A12", "A12"],
          ["A13", "A13"],
          ["A14", "A14"],
          ["A15", "A15"]
        ],
        ir_tx: [["3", "3"]],
        encoder_clk: [["2", "2"]],
        encoder_dt: [["3", "3"]],
        spi_mosi: [["51", "51"]],
        spi_miso: [["50", "50"]],
        spi_clk: [["52", "52"]],
        sd_cs: [["4", "4"]],
        picture: "media/Arduino-Mega-2560-Pinout.jpg",
        miniPicture: "media/Arduino-Mega-2560-Pinout-mini.jpg",
        serial: 9600,
        logic_levels: [
          ["%{BKY_BOOLEAN_ON}", "HIGH"],
          ["%{BKY_BOOLEAN_OFF}", "LOW"]
        ],
        ids: [
          ["1", "1"],
          ["2", "2"],
          ["3", "3"],
          ["4", "4"]
        ],
        sensor_range: [
          ["%", "PERCENT"],
          ["0..1023", "RAW"]
        ],
        intPins: [
          ["2", "2"],
          ["3", "3"],
          ["18", "18"],
          ["19", "19"],
          ["20", "20"],
          ["21", "21"]
        ],
        setupCode: [""],
        loopCode: [""],
        serialInt: [
          ["Serial", ""],
          ["Serial1", "1"],
          ["Serial2", "2"],
          ["Serial3", "3"]
        ]
      },
      wemos_d1: {
        description: "WeMos D1 / Mini",
        micro: "esp8266",
        digital: [
            ["D0", "16"],
            ["D1", "5"],
            ["D2", "4"],
            ["D3", "0"],
            ["D4", "2"],
            ["D5", "14"],
            ["D6", "12"],
            ["D7", "13"],
            ["D8", "15"],
            ["RX", "3"],
            ["TX", "1"]
        ],
        rxtx: [
            ["D0", "16"],
            ["D1", "5"],
            ["D2", "4"],
            ["D3", "0"],
            ["D4", "2"],
            ["D5", "14"],
            ["D6", "12"],
            ["D7", "13"],
            ["D8", "15"],
            ["RX", "3"],
            ["TX", "1"]
        ],
        PWM: [
            ["D1", "5"],
            ["D2", "4"],
            ["D3", "0"],
            ["D4", "2"],
            ["D5", "14"],
            ["D6", "12"],
            ["D7", "13"],
            ["D8", "15"],
            ["RX", "3"],
            ["TX", "1"]
        ],
        analog: [
            ["A0", "A0"]
        ],
        ir_rx: [
            ["D1", "5"],
            ["D2", "4"],
            ["D3", "0"],
            ["D4", "2"],
            ["D5", "14"],
            ["D6", "12"],
            ["D7", "13"],
            ["D8", "15"]
        ],
        ir_tx: [
            ["D1", "5"],
            ["D2", "4"],
            ["D3", "0"],
            ["D4", "2"],
            ["D5", "14"],
            ["D6", "12"],
            ["D7", "13"],
            ["D8", "15"]
        ],
        encoder_clk: [
            ["D1", "5"],
            ["D2", "4"],
            ["D5", "14"],
            ["D6", "12"],
            ["D7", "13"]
        ],
        encoder_dt: [
            ["D1", "5"],
            ["D2", "4"],
            ["D5", "14"],
            ["D6", "12"],
            ["D7", "13"]
        ],
        spi_mosi: [
            ["D7", "13"]
        ],
        spi_miso: [
            ["D6", "12"]
        ],
        spi_clk: [
            ["D5",
                "14"
            ]
        ],
        sd_cs: [
            ["D8", "15"]
        ],
        picture: "media/WeMosD1.jpg",
        miniPicture: "media/WeMosD1_mini.jpg",
        serial: 9600,
        logic_levels: [
            ["ON", "HIGH"],
            ["OFF", "LOW"]
        ],
        ids: [
            ["1", "1"],
            ["2", "2"],
            ["3", "3"],
            ["4", "4"]
        ],
        sensor_range: [
            ["%", "PERCENT"],
            ["0..1023", "RAW"]
        ],
        intPins: [
            ["D1", "5"],
            ["D2", "4"],
            ["D3", "0"],
            ["D4", "2"],
            ["D5", "14"],
            ["D6", "12"],
            ["D7", "13"],
            ["D8", "15"],
            ["RX", "3"],
            ["TX", "1"]
        ],
        setupCode: [""],
        loopCode: ["\tyield();\n"],
        serialInt: [
            ["Serial", ""]
        ]
      },
    };
    profile["default"] = profile.arduino_uno;

    /**
     * List of outer-inner pairings that do NOT require parentheses.
     * @type {!Array.<!Array.<number>>}
     */
    Blockly.Arduino.ORDER_OVERRIDES = [
      // (foo()).bar -> foo().bar
      // (foo())[0] -> foo()[0]
      [Blockly.Arduino.ORDER_FUNCTION_CALL, Blockly.Arduino.ORDER_MEMBER],
      // (foo())() -> foo()()
      [Blockly.Arduino.ORDER_FUNCTION_CALL, Blockly.Arduino.ORDER_FUNCTION_CALL],
      // (foo.bar).baz -> foo.bar.baz
      // (foo.bar)[0] -> foo.bar[0]
      // (foo[0]).bar -> foo[0].bar
      // (foo[0])[1] -> foo[0][1]
      [Blockly.Arduino.ORDER_MEMBER, Blockly.Arduino.ORDER_MEMBER],
      // (foo.bar)() -> foo.bar()
      // (foo[0])() -> foo[0]()
      [Blockly.Arduino.ORDER_MEMBER, Blockly.Arduino.ORDER_FUNCTION_CALL],
      // !(!foo) -> !!foo
      [Blockly.Arduino.ORDER_LOGICAL_NOT, Blockly.Arduino.ORDER_LOGICAL_NOT],
      // a * (b * c) -> a * b * c
      [Blockly.Arduino.ORDER_MULTIPLICATION, Blockly.Arduino.ORDER_MULTIPLICATION],
      // a + (b + c) -> a + b + c
      [Blockly.Arduino.ORDER_ADDITION, Blockly.Arduino.ORDER_ADDITION],
      // a && (b && c) -> a && b && c
      [Blockly.Arduino.ORDER_LOGICAL_AND, Blockly.Arduino.ORDER_LOGICAL_AND],
      // a || (b || c) -> a || b || c
      [Blockly.Arduino.ORDER_LOGICAL_OR, Blockly.Arduino.ORDER_LOGICAL_OR]
    ];

    /**
     * Whether the init method has been called.
     * @type {?boolean}
     */
    Blockly.Arduino.isInitialized = false;

    /**
     * Initialise the database of variable names.
     * @param {!Blockly.Workspace} workspace Workspace to generate code from.
     */
    Blockly.Arduino.init = function(workspace) {
      // Call Blockly.Generator's init.
      Object.getPrototypeOf(this).init.call(this);

      // Create a dictionary of definitions to be printed at the top of the sketch
      Blockly.Arduino.includes_ = [];
      // Create a dictionary of global definitions to be printed after variables
      Blockly.Arduino.definitions_ = Object.create(null);
      // Create a dictionary of variables
      Blockly.Arduino.variables_ = Object.create(null);
      // Create a dictionary of functions from the code generator
      Blockly.Arduino.codeFunctions_ = Object.create(null);
      // Create a dictionary of functions created by the user
      Blockly.Arduino.userFunctions_ = Object.create(null);
      // Create a dictionary mapping desired function names in definitions_
      // to actual function names (to avoid collisions with user functions)
      Blockly.Arduino.functionNames_ = Object.create(null);
      // Create a dictionary of setups to be printed in the setup() function
      Blockly.Arduino.setups_ = Object.create(null);

      // Create a dictionary for allowed blocks to gen code (modification need in generator.js core)
      Blockly.gencode_allowed_blocks = "control_arduino_setup control_arduino_loop procedures_defnoreturn procedures_defreturn io_interrupt blynk_app_read blynk_app_write blynk_connected blynk_app_connected blynk_app_disconnected blynk_timer serial_interrupt".split(
        " "
      );

      // Create counters for specific actuators
      Blockly.Arduino.ledmatrix_count = 0;
      Blockly.Arduino.ledmatrix_count2 = 0;
      Blockly.Arduino.lcd_count = 10;

      // Create a dictionari for extradata
      Blockly.Arduino.extra_data = Object.create(null);

      // Create a dictionary of global definitions to be printed after functions
      Blockly.Arduino.definitions_fnc_ = Object.create(null);

      // Create a dictionary of code (setups) to be printed in the arduino setup() function
      Blockly.Arduino.setups0_ = Object.create(null);

      // Create a dictionary of code (loops) to be printed in the arduino main loop() function
      Blockly.Arduino.loops_ = Object.create(null);

      // Create a dictionary of code (mqtt) to be printed in the mqtt function
      Blockly.Arduino.mqtt_sub_ = Object.create(null);

      if (!this.nameDB_) {
        this.nameDB_ = new Blockly.Names(this.RESERVED_WORDS_);
      } else {
        this.nameDB_.reset();
      }

      this.nameDB_.setVariableMap(workspace.getVariableMap());
      this.nameDB_.populateVariables(workspace);
      this.nameDB_.populateProcedures(workspace);

      var defvars = [];
      // Add developer variables (not created or named by the user).
      var devVarList = Blockly.Variables.allDeveloperVariables(workspace);
      for (var i = 0; i < devVarList.length; i++) {
        defvars.push(this.nameDB_.getName(devVarList[i], Blockly.Names.DEVELOPER_VARIABLE_TYPE));
      }

      // // Variable´s type
      // var allTypes = workspace.getVariableTypes();
      // console.log("--------------------");
      // console.log("--------------------");
      // console.log("Var Tipos:");
      // console.log(allTypes);

      // // Used Var
      // // Add user variables, but only ones that are being used.
      //   var variables = Blockly.Variables.allUsedVarModels(workspace);
      //   console.log("Used Var:");
      //   console.log(variables);

      // Argument Var
      // Add procedure argument user variables, but only ones that are being used.
      var varProcedure = workspace.getVariablesOfType("");
      // console.log("All Var Type '':");
      // console.log(varProcedure);
/*
       var defvars = [];
      for (var i = 0; i < varProcedure.length; i++) {
        defvars.push(this.nameDB_.getName(varProcedure[i].getId(), Blockly.VARIABLE_CATEGORY_NAME));
      }
      if (defvars.length) {
        this.definitions_["variables_procedure"] = "double " + defvars.join(", ") + ";";
      }
*/
      // Numeric Var
      // Add Numeric user variables, but only ones that are being used.
      var varNumeric = workspace.getVariablesOfType("Number");
      // console.log("All Var Type 'Numeric':");
      // console.log(varNumeric);
      var defvars = [];
      for (var i = 0; i < varNumeric.length; i++) {
        defvars.push(this.nameDB_.getName(varNumeric[i].getId(), Blockly.VARIABLE_CATEGORY_NAME));
      }
      if (defvars.length) {
        this.definitions_["variables"] = "double " + defvars.join(", ") + ";";
      }

      // String Var
      // Add String user variables, but only ones that are being used.
      var varString = workspace.getVariablesOfType("String");
      // console.log("All Var Type 'String':");
      // console.log(varString);
      var defvars = [];
      for (var i = 0; i < varString.length; i++) {
        defvars.push(this.nameDB_.getName(varString[i].getId(), Blockly.VARIABLE_CATEGORY_NAME));
      }
      if (defvars.length) {
        this.definitions_["variables_text"] = "String " + defvars.join(", ") + ";";
      }

      // Bool Var
      // Add Boolean user variables, but only ones that are being used.
      var varBool = workspace.getVariablesOfType("Bool");
      // console.log("All Var Type 'Bool':");
      // console.log(varBool);
      var defvars = [];
      for (var i = 0; i < varBool.length; i++) {
        defvars.push(this.nameDB_.getName(varBool[i].getId(), Blockly.VARIABLE_CATEGORY_NAME));
      }
      if (defvars.length) {
        this.definitions_["variables_bool"] = "boolean " + defvars.join(", ") + ";";
      }

      this.isInitialized = true;
    };

    /**
     * Prepend the generated code with the variable definitions.
     * @param {string} code Generated code.
     * @return {string} Completed code.
     */
     Blockly.Arduino.finish = function(code) {
      let functions = [];
      let definitions = [];
      let setups = [];
      let output = [];
      let includes = [];
      let loop_ = [];

      for (var c = 0; c < profile["default"].loopCode.length; c++)
        "" != profile["default"].loopCode[c] && loop_.push(profile["default"].loopCode[c]);

      for (var d in Blockly.Arduino.loops_) (c = Blockly.Arduino.loops_[d]), loop_.push(c);

      for (d in Blockly.Arduino.definitions_) {
        c = Blockly.Arduino.definitions_[d];
        c.match(/^#include/) ? includes.push(c) : definitions.push(c);
        // if (c.match(/^#include/)) {
        //   includes.push(c);
        // }
        // else if (c.match("Describe")) {
        //   functions.push(c);
        // }
        // else {
        //   definitions.push(c);
        // }
      }

      for (d in Blockly.Arduino.definitions_fnc_) {
        (c = Blockly.Arduino.definitions_fnc_[d]), functions.push(c);
      }

      for (d in Blockly.Arduino.setups0_) {
        "arduino_setup" != d && setups.push(Blockly.Arduino.setups0_[d]);
      }

      for (c = 0; c < profile["default"].setupCode.length; c++) {
        "" != profile["default"].setupCode[c] && setups.push(profile["default"].setupCode[c]);
      }

      for (d in Blockly.Arduino.setups_) {
        "arduino_setup" != d && setups.push(Blockly.Arduino.setups_[d]);
      }

      (d = Blockly.Arduino.setups_.arduino_setup) && setups.push(d);

          output =
          (
          ( includes.length?
            "/** Includes *****************************/\n" +
            includes.join("\n") +
            "\n\n" : ""
          ) +
          ( definitions.length?
            "/** Definitions **************************/\n" +
            definitions.join("\n") +
            "\n\n" : ""
          ) +
          ( functions.length?
            "/** Functions ****************************/\n" +
            functions.join("\n") +
            "\n\n" : ""
          ) +
          (
          "/** Setup function ***********************/\n" +
          "void setup() {\n" +
          setups.join("\n") +
          // setups.join("\n") + (setups? "\n" : "") +
          "}\n\n"
          ) +
          (
          "/** Loop function ************************/\n" +
          "void loop() {\n" +
          loop_.join("\n") +
          code +
          "}\n\n"
          ))
          .replace(/\n\n+/g, "\n\n")
          .replace(/\n*$/, "\n\n\n")
          ;
          // .replace(/\n/g, "\n  ")
          // .replace(/\n\s+$/, "\n");

      return output;
    };

    /**
     * Naked values are top-level blocks with outputs that aren't plugged into
     * anything.  A trailing semicolon is needed to make this legal.
     * @param {string} line Line of generated code.
     * @return {string} Legal line of code.
     */
    Blockly.Arduino.scrubNakedValue = function(line) {
      return line + ";\n";
    };

    /**
     * Encode a string as a properly escaped Arduino string, complete with quotes.
     * @param {string} string Text to encode.
     * @return {string} Arduino string.
     * @private
     */
    Blockly.Arduino.quote_ = function(string) {
      // TODO: This is a quick hack.  Replace with goog.string.quote
      string = string
        .replace(/\\/g, "\\\\")
        .replace(/\n/g, "\\\n")
        .replace(/\$/g, "\\$")
        .replace(/'/g, "\\'");
      return '"' + string + '"';
    };

    /**
     * Common tasks for generating Arduino from blocks.
     * Handles comments for the specified block and any connected value blocks.
     * Calls any statements following this block.
     * @param {!Blockly.Block} block The current block.
     * @param {string} code The Arduino code created for this block.
     * @param {boolean=} opt_thisOnly True to generate code for only this statement.
     * @return {string} Arduino code with comments and subsequent blocks added.
     * @private
     */
    Blockly.Arduino.scrub_ = function(block, code, opt_thisOnly) {
      if (code === null) {
        // Block has handled code generation itself.
        return "";
      }
      var commentCode = "";
      // Only collect comments for blocks that aren't inline.
      if (!block.outputConnection || !block.outputConnection.targetConnection) {
        // Collect comment for this block.
        var comment = block.getCommentText();
        if (comment) {
          commentCode += Blockly.Arduino.prefixLines(comment, "// ") + "\n";
        }
        // Collect comments for all value arguments.
        // Don't collect comments for nested statements.
        for (var x = 0; x < block.inputList.length; x++) {
          if (block.inputList[x].type == Blockly.INPUT_VALUE) {
            var childBlock = block.inputList[x].connection.targetBlock();
            if (childBlock) {
              var comment = Blockly.Arduino.allNestedComments(childBlock);
              if (comment) {
                commentCode += Blockly.Arduino.prefixLines(comment, "// ");
              }
            }
          }
        }
      }
      var nextBlock = block.nextConnection && block.nextConnection.targetBlock();
      var nextCode = Blockly.Arduino.blockToCode(nextBlock);
      return commentCode + code + nextCode;
    };

    /**
     * Common tasks for generating Arduino from blocks.
     * Handles comments for the specified block and any connected value blocks.
     * Calls any statements following this block.
     * @param {!Blockly.Block} block The current block.
     * @param {string} code The Arduino code created for this block.
     * @return {string} Arduino code with comments and subsequent blocks added.
     * @private
     */
    Blockly.Arduino.scrub_ = function(a, b) {
      if (null === b) return "";
      var c = "";
      if (!a.outputConnection || !a.outputConnection.targetConnection) {
        var d = a.getCommentText();
        d && (c += Blockly.Arduino.prefixLines(d, "// ") + "\n");
        for (var e = 0; e < a.inputList.length; e++)
          a.inputList[e].type == Blockly.INPUT_VALUE &&
            (d = a.inputList[e].connection.targetBlock()) &&
            (d = Blockly.Arduino.allNestedComments(d)) &&
            (c += Blockly.Arduino.prefixLines(d, "// "));
      }
      e = a.nextConnection && a.nextConnection.targetBlock();
      e = Blockly.Arduino.blockToCode(e);
      return c + b + e;
    };

    return [profile, img_path];
}
